import { createSelector } from 'reselect';
import { find, propEq, values } from 'ramda';


const selectIsProfileDelAvalable = createSelector(
  [
    state => state.students.data,
  ],
  (studentsData) => {
    return !find(propEq('externalSystemSync', true), values(studentsData));
  }
);

export default selectIsProfileDelAvalable;
